export const formatIDR = (n) => {
  if (n === null || n === undefined || isNaN(n)) return "Rp0";
  return "Rp" + Number(n).toLocaleString("id-ID", { maximumFractionDigits: 0 });
};

export const formatNumber = (n) => {
  if (n === null || n === undefined || isNaN(n)) return "0";
  return Number(n).toLocaleString("id-ID");
};

export const formatDate = (iso) => {
  if (!iso) return "-";
  try {
    return new Date(iso).toLocaleDateString("id-ID", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return "-";
  }
};

export const formatDateTime = (iso) => {
  if (!iso) return "-";
  try {
    return new Date(iso).toLocaleString("id-ID", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch {
    return "-";
  }
};

export const statusColor = (s) => {
  switch (s) {
    case "new": return "bg-blue-50 text-blue-700 border-blue-200";
    case "active": return "bg-emerald-50 text-emerald-700 border-emerald-200";
    case "repeat": return "bg-amber-50 text-amber-700 border-amber-200";
    case "loyal": return "bg-purple-50 text-purple-700 border-purple-200";
    case "at_risk": return "bg-orange-50 text-orange-700 border-orange-200";
    case "inactive": return "bg-gray-100 text-gray-700 border-gray-200";
    default: return "bg-gray-100 text-gray-700 border-gray-200";
  }
};

export const statusLabel = (s) => {
  const map = { new: "Baru", active: "Aktif", repeat: "Repeat", loyal: "Loyal", at_risk: "Berisiko", inactive: "Non-aktif" };
  return map[s] || s;
};

export const tierColor = (t) => {
  switch (t) {
    case "bronze": return "bg-amber-50 text-amber-800 border-amber-200";
    case "silver": return "bg-gray-100 text-gray-700 border-gray-300";
    case "gold": return "bg-yellow-50 text-yellow-800 border-yellow-300";
    case "platinum": return "bg-purple-50 text-purple-800 border-purple-300";
    default: return "bg-gray-100 text-gray-700 border-gray-200";
  }
};

export const platformLabel = (p) => {
  const map = { shopee: "Shopee", tiktok: "TikTok Shop", tokopedia: "Tokopedia", lazada: "Lazada", instagram: "Instagram", whatsapp: "WhatsApp", offline: "Offline" };
  return map[p] || p || "-";
};
